/* === Horizon (Collection Cards): 200ms-Haltezeit, Slide #2 bis Finger hoch === */
(function () {
  if (!(window.matchMedia && window.matchMedia('(hover: none)').matches)) return;

  const HOLD_DELAY = 200;       // ms bis Vorschau aktiv wird
  const MOVE_THRESHOLD = 10;     // px Bewegung, ab der wir sofort previewen

  const isInteractive = (el) =>
    !!el.closest('button,[role="button"],input,select,textarea,.quick-add,.quick-add__submit,.product-form__submit,a[href^="#"]');

  const findCard = (start) => start.closest('.product-card, product-card');

  function findSlideshow(card) {
    const comp = card.querySelector('slideshow-component');
    if (!comp) return null;
    const slidesContainer = comp.querySelector('slideshow-slides') || comp;
    let slides = Array.from(slidesContainer.querySelectorAll('slideshow-slide, .slideshow__slide, [data-media-id]'));
    if (slides.length < 2) return null;
    const current = slides.find((s) => !s.hasAttribute('hidden')) || slides[0];
    const second = slides[1];
    return { mode: 'slideshow', comp, slides, current, second };
  }

  function findStack(card) {
    const candidates = card.querySelectorAll('.card__media, .media--hover-effect, .product-card__media, .product-media, .media, .card-gallery');
    for (const c of candidates) {
      const kids = Array.from(c.children).filter((el) => el.tagName !== 'NOSCRIPT');
      if (kids.length >= 2) return { mode: 'stack', container: c, first: kids[0], second: kids[1] };
    }
    return null;
  }

  let active = null;          // aktiver Preview-Mode
  let pendingCard = null;     // Karte, die evtl. gleich previewt
  let timerId = null;         // Haltezeit-Timer
  let startX = 0, startY = 0; // Startkoordinaten

  function previewStart(card) {
    let m = findSlideshow(card);
    if (m) {
      if (m.second === m.current) { active = { ...m, card }; return true; }
      m.comp.setAttribute('data-touch-previewing', '');
      m._prev = {
        currentHidden: m.current.hasAttribute('hidden'),
        secondHidden: m.second.hasAttribute('hidden'),
        currentAria: m.current.getAttribute('aria-hidden'),
        secondAria: m.second.getAttribute('aria-hidden')
      };
      m.current.setAttribute('hidden', '');
      m.current.setAttribute('aria-hidden', 'true');
      m.second.removeAttribute('hidden');
      m.second.setAttribute('aria-hidden', 'false');
      active = { ...m, card };
      return true;
    }
    m = findStack(card);
    if (m) {
      m.container.setAttribute('data-touch-previewing', '');
      m._prev = { firstOpacity: m.first.style.opacity, secondOpacity: m.second.style.opacity };
      m.first.style.opacity = '0';
      m.second.style.opacity = '1';
      active = { ...m, card };
      return true;
    }
    return false;
  }

  function previewClear() {
    if (!active) return;
    if (active.mode === 'slideshow') {
      const m = active;
      m.comp.removeAttribute('data-touch-previewing');
      if (!m._prev.currentHidden) m.current.removeAttribute('hidden'); else m.current.setAttribute('hidden', '');
      if (m._prev.currentAria == null) m.current.removeAttribute('aria-hidden'); else m.current.setAttribute('aria-hidden', m._prev.currentAria);
      if (m._prev.secondHidden) m.second.setAttribute('hidden', ''); else m.second.removeAttribute('hidden');
      if (m._prev.secondAria == null) m.second.removeAttribute('aria-hidden'); else m.second.setAttribute('aria-hidden', m._prev.secondAria);
    } else {
      const m = active;
      m.container.removeAttribute('data-touch-previewing');
      m.first.style.opacity = m._prev.firstOpacity || '';
      m.second.style.opacity = m._prev.secondOpacity || '';
    }
    active = null;
  }

  function clearTimer() { if (timerId) { clearTimeout(timerId); timerId = null; } }

  const onDown = (e) => {
    if (e.pointerType && e.pointerType !== 'touch') return;
    if (isInteractive(e.target)) return;

    const card = findCard(e.target);
    if (!card) return;

    if (active && active.card !== card) previewClear();

    pendingCard = card;
    const p = (e.touches && e.touches[0]) ? e.touches[0] : e;
    startX = p.clientX; startY = p.clientY;

    clearTimer();
    timerId = setTimeout(() => {
      if (pendingCard) {
        previewStart(pendingCard);
        pendingCard = null;
      }
      timerId = null;
    }, HOLD_DELAY);
  };

  const onMove = (e) => {
    if (!pendingCard) return; // schon aktiv oder nichts pending
    const p = (e.touches && e.touches[0]) ? e.touches[0] : e;
    const dx = p.clientX - startX;
    const dy = p.clientY - startY;
    if ((dx*dx + dy*dy) >= (MOVE_THRESHOLD * MOVE_THRESHOLD)) {
      // Nutzer beginnt zu wischen/scrollen: sofort previewen
      clearTimer();
      previewStart(pendingCard);
      pendingCard = null;
    }
  };

  const onUp = (e) => {
    if (e.pointerType && e.pointerType !== 'touch') return;
    clearTimer();
    pendingCard = null;
    // War Preview aktiv? Dann jetzt zurück
    previewClear();
  };

  const optPassive = { passive: true };
  document.addEventListener('pointerdown', onDown, optPassive);
  document.addEventListener('pointermove', onMove, optPassive);
  document.addEventListener('pointerup', onUp, optPassive);
  document.addEventListener('touchstart', onDown, optPassive);
  document.addEventListener('touchmove', onMove, optPassive);
  document.addEventListener('touchend', onUp, optPassive);

  // Kein Reset auf scroll/cancel – Bild 2 bleibt bis Finger hoch.
  document.addEventListener('visibilitychange', () => { if (document.hidden) { clearTimer(); pendingCard = null; previewClear(); }});
})();
